import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const YoutubeIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 14" cursor="pointer" {...props}>
            <path
                d="M10.2963 0.000854492C11.2952 0.00508563 14.6444 0.0318826 17.0012 0.201598C17.3919 0.247628 18.2444 0.25136 19.005 1.04445C19.6044 1.64844 19.8 3.02001 19.8 3.02001C19.8 3.02001 19.9681 4.37374 19.9961 5.83981L20 6.2415V7.75178C20 9.36284 19.8 10.9733 19.8 10.9733C19.8 10.9733 19.6044 12.3448 19.005 12.9488C18.2444 13.7419 17.3919 13.7457 17.0012 13.7923C14.2025 13.9938 10 14.0001 10 14.0001C10 14.0001 4.8 13.9528 3.2 13.7998C2.755 13.717 1.75563 13.7419 0.994375 12.9488C0.395 12.3448 0.2 10.9733 0.2 10.9733C0.2 10.9733 0 9.36284 0 7.75178V6.2415C0 4.63106 0.2 3.02001 0.2 3.02001C0.2 3.02001 0.395 1.64844 0.994375 1.04445C1.75563 0.25136 2.6075 0.247628 2.99875 0.201598C5.35559 0.0318826 8.70479 0.00508563 9.70367 0.000854492H10.2963ZM7.5 4.26093L7.50062 9.85359L12.9037 7.0669L7.5 4.26093Z"
                fill="currentColor"
            />
        </Icon>
    )
}

YoutubeIcon.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
}

export default YoutubeIcon
